<template>
    <div>
        <div class="text-center p-10 max-w-[500px] mx-auto">
            <!-- Page content -->
            <div>
                <!-- Company logo -->
                <img class="h-[50px] mx-auto mb-10" :src="$companyTool.confFile().style.logo">

                <div class="mb-10">{{ $tt("Vous êtes sur le point d'ajouter une photo dans votre dossier SAV") }}</div>
                <div v-show="!file">
                    <button class="px-8 py-4 text-lg font-bold bg-green-100 border border-green-400 rounded" @click="openInput"><i class="fas fa-camera mr-2"></i> {{ $tt('Prendre une photo') }}</button>
                    <sav-input v-model="file" type="file" :options="{take_photo: 0, camera: 1}" label="Prendre une photo" class="fixed -mt-[4000px] -ml-[4000px]" />
                </div>
    
                <div v-if="file">
                    <img :src="file.url" class="w-[50%] mx-auto mb-10 rounded">
                    <button class="px-8 py-4 text-lg w-full font-bold bg-green-100 border border-green-400 rounded mb-4" @click="sendFile">{{ $tt('Confirmer cette photo') }}</button>
                    <button class="px-8 py-4 w-full rounded mb-4" @click="openInput"><i class="fas fa-redo mr-1.5 text-sm"></i> {{ $tt('Reprendre la photo') }}</button>
                </div>
            </div>
        </div>
        <!-- Langs -->
        <div class="fixed bottom-7 left-0 right-0" v-if="langage && $companyTool.confFile().translates">
            <div class="flex items-center justify-around">
                <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'menu-lang-' + langIndex" style="text-decoration: none">
                    <img class="h-[15px] cursor-pointer hover:opacity-50 duration-200" :src="lang.logo" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    data() {
        return {
            file: null,
            langage: null,
            langs: null,
        }
    },
    methods: {
        async sendFile() {
            await apiService.post('socket.take-photo', {
                data: JSON.stringify(this.file),
                event_id: this.$route.params.id,
                no_user: 1
            }, 'api2')
            this.$router.push({name: 'take-picture-success'})
        },

        openInput() {
            let el = document.getElementById('prendre-une-photo')
            if (el) {
                el.click()
            }
        },

        changeLangage(lang) {
            localStorage.setItem('langage', lang)
            location.reload()
        },
        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        }
    },

    async mounted() {
        // Lang
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/companies/default/views/form/TakePicture.vue